import type { GetterTree } from 'vuex'
import type { RootState } from '@/store'
import type { MapState } from './types'
import { MAP_GETTERS } from './types'

interface IMapGetters extends GetterTree<MapState, RootState> {
  [MAP_GETTERS.GET_MEASUREMENT_TYPE](state: MapState): number
  [MAP_GETTERS.GET_AQI_TYPE](state: MapState): number
  [MAP_GETTERS.GET_DEVICE_MODELS](state: MapState): string[] | null
  [MAP_GETTERS.GET_SHOW_MINE](state: MapState): boolean
  [MAP_GETTERS.GET_SHOW_PUBLIC](state: MapState): boolean
  [MAP_GETTERS.GET_SHOW_SHARED](state: MapState): boolean
  [MAP_GETTERS.GET_SHOW_INDOOR](state: MapState): boolean
  [MAP_GETTERS.GET_SHOW_OUTDOOR](state: MapState): boolean
}

const getters: IMapGetters = {
  [MAP_GETTERS.GET_MEASUREMENT_TYPE](state) {
    return state.shownSettings.pinMeasurementType
  },
  [MAP_GETTERS.GET_AQI_TYPE](state) {
    return state.shownSettings.pinAqiType
  },
  [MAP_GETTERS.GET_DEVICE_MODELS](state) {
    return state.shownSettings.deviceModels
  },
  [MAP_GETTERS.GET_SHOW_MINE](state) {
    return state.shownSettings.showMine
  },
  [MAP_GETTERS.GET_SHOW_PUBLIC](state) {
    return state.shownSettings.showPublic
  },
  [MAP_GETTERS.GET_SHOW_SHARED](state) {
    return state.shownSettings.showShared
  },
  [MAP_GETTERS.GET_SHOW_INDOOR](state) {
    return state.shownSettings.showIndoor
  },
  [MAP_GETTERS.GET_SHOW_OUTDOOR](state) {
    return state.shownSettings.showOutdoor
  }
}

export default getters
